<template>
    <div class="NotificationMasterSwitch">
        <SwitchToggle hide-label :value="value" @input="$emit('input', $event)" />
        <label
            :class="value ? 'text-eidTrustGreen' : 'text-eidSecureBlue-75'"
            @click="$emit('input', !value)"
        >
            Notifications On
        </label>
    </div>
</template>

<style lang="scss">
    .NotificationMasterSwitch {
        display: flex;
        align-items: center;
        gap: 10px;
        color: var(--eidTechGray);
        font-size: 16px;

        .SwitchToggle {
            padding-left: 0;
        }

        label {
            cursor: pointer;
        }

        .SwitchToggle__container {
            width: 40px;
            height: 22px;
        }

        .SwitchToggle__slider:before {
            height: 15px;
            width: 15px;
            left: 3px;
            bottom: 4px;
        }

        .SwitchToggle__slider {
            @apply bg-eidTechGray;
        }

        // stylelint-disable
        .SwitchToggle input:checked + .SwitchToggle__slider:before {
            transform: translateX(19px);
            // stylelint-enable
        }
    }
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { SwitchToggle } from '@evidentid/dashboard-commons/components/SwitchToggle';

    export default defineComponent({
        name: 'NotificationMasterSwitch',
        components: { SwitchToggle },
        props: {
            value: {
                type: Boolean,
                default: false,
            },
        },
        emits: [ 'input' ],
    });
</script>
